<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col cols="12" v-if="changePassword">
            <div class="rowinfo">
              <v-text-field
                v-model="computedValue"
                outlined
                dense
                clearable
                label="رمز عبور"
                class="contentinfo"
                :append-icon="`mdi-${show ? 'eye' : 'lock'}`"
                @click:append="show = !show"
                clear-icon="mdi-close-circle-outline"
                :type="show ? 'text' : 'password'"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-computedValue`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="رمز عبور"
              />
            </div>
          </v-col>

          <v-col cols="12" class="d-flex" v-if="removePassword">
            <div class="rowinfo" v-if="!changePassword">
              <v-btn
                text
                color="primary"
                @click="changePassword = true"
                class="contentinfo"
              >
                <v-icon left>mdi-pencil</v-icon>
                ویرایش
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-edit-changePassword`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ویرایش"
              />
            </div>
            <div class="rowinfo" v-else>
              <v-btn
                text
                color="primary"
                @click="changePassword = false"
                class="contentinfo"
              >
                <v-icon left>mdi-close</v-icon>
                لغو
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-cancel-changePassword`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="لغو"
              />
            </div>

            <v-spacer />
            <div class="rowinfo">
              <v-btn
                outlined
                color="third"
                @click="deletePass"
                :loading="loading"
              >
                <v-icon left>mdi-delete</v-icon>
                حذف رمز عبور فعلی
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-delete-Password`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="حذف رمز عبور فعلی"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "managePasswordQr",

  props: {
    value: [String, Number],
    data: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "manager-passwordQr",
    loading: false,
    show: false,
    removePassword: false,
    changePassword: true,
  }),

  mounted() {
    if (this.value) {
      this.changePassword = false;
      this.removePassword = true;
      this.computedValue = "";
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    changePassword(val) {
      this.computedValue = "";
    },
  },

  methods: {
    deletePass() {
      this.loading = true;

      this.$api
        .post("/v1/testQr/reset-password", {
          identifier: this.$route.params.id,
        })
        .then(({ data }) => {
          this.computedValue = null;
          this.removePassword = false;
          this.changePassword = true;
        })
        .catch(({ response }) =>
          console.log("error in reset password: ", response),
        )
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
